import { Box, Flex, GridItem, Image, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

import { RanaButton } from "@nens/ranalib";

import { RanaTags } from "@/components/ranatags";

const ALIGN_ITEMS = { left: "flex-start", center: "center" } as const;

type LargeTileCardProps = {
  title: ReactNode;
  description?: ReactNode;
  tags?: string[];
  height: string | number;
  imageSrc?: string;
  imageAlt: string;
  footer?: ReactNode;
  textAlign?: "left" | "center";
  onClick: () => void;
};

export const LargeTileCard = ({
  title,
  description,
  tags,
  height,
  imageSrc,
  imageAlt,
  footer,
  textAlign = "left",
  onClick,
}: LargeTileCardProps) => {
  return (
    <GridItem position="relative" h={height}>
      <RanaButton variant="listitem" h="full" w="full" onClick={onClick}>
        <Flex w="full" h="full" flexDir="column">
          {!!tags?.length && (
            <Box
              position="absolute"
              top={0}
              left={0}
              right={0}
              h={36}
              p={4}
              zIndex={1}
              overflow="hidden"
            >
              <RanaTags tags={tags} fontSize="xs" />
            </Box>
          )}
          <Box
            flexGrow={1}
            minH={0}
            w="full"
            rounded="base"
            overflow="hidden"
            bg={imageSrc ? undefined : "brand.grey.300"}
          >
            {imageSrc && (
              <Image w="full" h="full" src={imageSrc} objectFit="cover" alt={imageAlt} />
            )}
          </Box>
          <Flex
            flexShrink={0}
            py={4}
            px={2}
            flexDir="column"
            alignItems={ALIGN_ITEMS[textAlign]}
            justifyContent="center"
            textAlign={textAlign}
            overflow="hidden"
          >
            {title}
            {description && (
              <Text mt={2} fontSize="sm" fontWeight="normal" noOfLines={2}>
                {description}
              </Text>
            )}
          </Flex>
          {footer}
        </Flex>
      </RanaButton>
    </GridItem>
  );
};
